import { render, staticRenderFns } from "./ValueInsights.vue?vue&type=template&id=38a0ad46"
import script from "./ValueInsights.vue?vue&type=script&lang=js"
export * from "./ValueInsights.vue?vue&type=script&lang=js"
import style0 from "./ValueInsights.vue?vue&type=style&index=0&id=38a0ad46&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports